/**
 * BrandyOrWinebrandType
 */
export type BrandyOrWinebrandType = 'BRANDY_DE_JEREZ' | 'OTHER';

export const BrandyOrWinebrandType = {
  BrandyDeJerez: 'BRANDY_DE_JEREZ' as BrandyOrWinebrandType,
  Other: 'OTHER' as BrandyOrWinebrandType,
};
